
































import Vue from 'vue';
import {
  ScheduledTransactions,
  PendingTransactions,
} from '@/components/account-components/account-activity-components/account-activity-child-components';
import { PendingTransactionResponseModel, ScheduledTransactionResponseModel } from '@/@types/member';

/**
 * The expander that houses the scheduled and pending transactions.
 * @see See [ScheduledTransactions](#scheduledtransactions)
 * @see See [PendingTransactions](#pendingtransactions)
 */
export default Vue.extend({
  name: 'AccountActivityExpander',
  data() {
    return {
      isLoading: true,
    };
  },
  computed: {
    scheduledTransactions(): ScheduledTransactionResponseModel[] {
      return this.$store.getters.scheduledTransactions;
    },
    pendingTransactions(): PendingTransactionResponseModel[] {
      return this.$store.getters.pendingTransactions;
    },
  },
  components: {
    ScheduledTransactions,
    PendingTransactions,
  },
});
